import { getCookiesRootDomain } from '../utils/location';

export const COOKIES_ROOT_DOMAIN = getCookiesRootDomain();
export const { TEAMS_WEB_ROOT } = process.env;
